import React, { useState, useEffect, useMemo } from "react";
import "../../Styles/TableStyles.scss";
import {
  // useTable,
  Column,
  //  useSortBy
} from "react-table";
import EventServices from "../../services/EventServices";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
// import // changeCurrentMemberMenu,
// // screenChange
// "../../store/screenSlice";
// import { screenConfig } from "../../config/screenConfig";
import { useAppSelector, useAppDispatch } from "../../store/hooks";
import { RootState } from "../../store/store";
import dayjs from "dayjs";
import RoundButtonWithIcon from "../StyledComp/RoundButtonWithIcon";
import LeftArrowIcon from "../../Images/LeftArrowIcon";
// import { AiOutlineCloseCircle } from "react-icons/ai";
import {
  assignEvent,
  assignEventSearchParam,
  // setEventCurrentPage,
  // setSearchElement,
  // setUpdateSortBy,
  // setUpdateSortType,
} from "../../store/eventApiSlice";
// import {
//   assignCurrentEvent,
//   setEventCurrentPage,
//   setSearchElement,
//   setUpdateSortBy,
//   setUpdateSortType,
// } from "../../store/currentEventApiSlice";
import * as routeConfig from "../../config/routes";
import ButtonWithIcon from "../StyledComp/ButtonWithIcon";
import EventsIcon from "../../Images/MenuIconComp/EventsIcon";
import { IEvent, IEventSearchParam } from "../../store/eventApiSlice";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Nav from "react-bootstrap/Nav";
import AlertWithModal from "../utilityComponents/AlertWithModal";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { ILocation } from "../../store/orderApiSlice";

// interface Location {
//   LocationId: number | null;
//   Location: String | null;
//   Cost: number | null;
// }

// interface Cost {
//   CostId: number | null;
//   CostName: string | null;
//   Cost: number | null;
// }

// interface IEvent {
//   NumberOfAttendee: string | null;
//   Id: string | null;
//   EventName: string | null;
//   Description: string | null;
//   UniqueEventId: string | null;
//   EventType: string | null;
//   EventCategory: string | null;
//   StartDateTime: string | null;
//   EndDateTime: string | null;
//   EarlyBirdBy: string | null;
//   Available: number | null;
//   AvailableOnline: number | null;
//   SponsorName: string | null;
//   RegistrationLink: string | null;
//   ZoomMeetingID: string | null;
//   ZoomRegLink: string | null;
//   DECredits: number | null;
//   DEEnchEthics: number | null;
//   PACredits: number | null;
//   PAEthics: number | null;
//   Comments: string | null;
//   MaterialLink: string | null;
//   Locations: Location[] | null;
//   Costs: Cost[] | [];
// }

const EventList: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [eventList, setEventList] = useState<IEvent[]>([]);
  useEffect(() => {
    setEventList([]);
  }, []);
  const [locationList, setLocationList] = useState<ILocation[]>([]);
  // const [isAllSelected, setIsAllSelectd] = useState<boolean>(false);
  const updateSortBy = useSelector(
    (state: RootState) => state.eventapislice.eventSearchParam.SortBy
  );
  // const [SortField, setSortField] = useState(updateSortBy);

  // const event = useSelector((state: RootState) => state.eventapislice.event);
  const eventSearchParam = useSelector(
    (state: RootState) => state.eventapislice.eventSearchParam
  );

  const [CurrentAPICallPage, setCurrentAPICallPage] = useState(
    eventSearchParam.CurrentPage ?? 10
  );
  const [CurrentPage, setCurrentPage] = useState(
    eventSearchParam.CurrentPage ?? 1
  );
  const [EventPerAPICall, setEventPerAPICall] = useState(
    eventSearchParam.Paginate ?? 10
  );
  const [TotalRecords, setTotalRecords] = useState(0);
  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertBody, setAlertBody] = useState<string>("");
  const [alertTitle, setAlertTitle] = useState<string>("");
  const [showMoreModal, setShowMoreModal] = useState(false);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [selectedLocation, setSelectedLocation] = useState<number | null>(null);
  const [sponsorText, setSponsorText] = useState("");
  const [hasFilters, setHasFilters] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [eventToDelete, setEventToDelete] = useState<IEvent | null>(null);
  const [isDeleting, setIsDeleting] = useState(false);

  const getFilterText = () => {
    const filters = [];
    if (startDate) filters.push(`Start: ${dayjs(startDate).format('MM/DD/YYYY')}`);
    if (endDate) filters.push(`End: ${dayjs(endDate).format('MM/DD/YYYY')}`);
    if (selectedLocation) filters.push(`Location: ${locationList.find(l => l.Id === Number(selectedLocation))?.Location}`);
    if (sponsorText) filters.push(`Sponsor: ${sponsorText}`);
    return filters.length > 0 ? filters.join(', ') : 'More';
  };
  const [SortType, setSortType] = useState(eventSearchParam.SortType ?? "Desc");
  const [SortBy, setSortBy] = useState(
    eventSearchParam.SortBy ?? "StartDateTime"
  );
  const [searchInput, setSearchInput] = useState(
    eventSearchParam.searchElement ?? ""
  );
  const [FilterBy, setFilterBy] = useState(eventSearchParam.eventType ?? "");

  const [showInputs, setShowInputs] = useState(
    eventSearchParam.searchElement ?? ""
  );
  // const [searchvisibility, setSearchvisibility] = useState(false);
  let startIndex = 0;
  let endIndex = 0 + EventPerAPICall;
  // let eventListAPIParams = {
  //   SortType: SortType,
  //   SortBy: SortField,
  //   CurrentPage: CurrentAPICallPage,
  //   Paginate: EventPerAPICall,
  //   searchElement: searchInput,
  // };
  const roleCapabilites = useAppSelector(
    (state) => state.user.roleCapabilities
  );

  const columns = React.useMemo<Column<any>[]>(
    () => [
      { id: "Id", Header: "Event ID", accessor: "EventId" },
      { id: "EventName", Header: "Event Name", accessor: "EventName" },
      { id: "EventType", Header: "Event Type", accessor: "EventType" },
      {
        id: "StartDateTime",
        Header: "Event Start Date",
        accessor: (StartDateTime) => {
          return moment(StartDateTime.StartDateTime)
            .local()
            .format("MM-DD-YYYY HH:mm A");
        },
      },
      {
        id: "EndDateTime",
        Header: "Event End Date",
        accessor: (EndDateTime) => {
          return moment(EndDateTime.EndDateTime)
            .local()
            .format("MM-DD-YYYY  HH:mm A");
        },
      },
      // { id: "MemberType", Header: "MemberType", accessor: "MemberType" },
      // { id: "Gender", Header: "Gender", accessor: "Gender" },
    ],
    []
  );

  useEffect(() => {
    const getEventLists = async () => {
      const eventListAPIParams: IEventSearchParam = {
        CurrentPage: CurrentAPICallPage,
        Paginate: EventPerAPICall,
        SortBy: SortBy,
        SortType: SortType,
        searchElement: searchInput,
        eventType: FilterBy,
        startDate: startDate ? dayjs(startDate).format('YYYY-MM-DD') : '',
        endDate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : '',
        locationId: selectedLocation,
        sponsor: sponsorText
      };

      const response = await EventServices.getEventList(eventListAPIParams);
      dispatch(assignEventSearchParam(eventListAPIParams));
      console.log("eventListAPIParams", eventListAPIParams);
      console.log("response...", response.data.data);
      if (response.data.data != null) {
        if (response.data.hasErrors) {
          setShowAlertModal(true);
          setAlertTitle("Database Error");
          setAlertBody(response.data.errors[0].sqlMessage);
          return;
        }
        console.log("Success:", response.data.data);
        setTotalRecords(response.data.data.pagination[0].TotalRecords);
        setEventList(response.data.data.Events);
        // dispatch(updateEventList(response.data.data));
        // dispatch(setEventCurrentPage(eventListAPIParams.CurrentPage));
        // dispatch(setSearchElement(eventListAPIParams.searchElement));
        // dispatch(setUpdateSortType(eventListAPIParams.SortType));
        // dispatch(setUpdateSortBy(eventListAPIParams.SortBy));
      } else {
      }
    };

    
    const getLocationLists = async () => {
      const response = await EventServices.getConfigurableLocation();
      
      console.log("response...", response.data.data);
      if (response.data.data != null) {
        
        console.log("Success:", response.data.data);
        setLocationList(response.data.data);
      } 
    };

    

    getEventLists();
    getLocationLists();
  }, [
    SortBy,
    SortType,
    CurrentAPICallPage,
    searchInput,
    EventPerAPICall,
    FilterBy,
    hasFilters
  ]);

  const handleApplyFilters = async () => {
    setHasFilters(true);
    setShowMoreModal(false);
    setCurrentAPICallPage(1);
    await getEventLists();
  };

  const getEventLists = async () => {
    try {
      const response = await EventServices.getEventList({
        CurrentPage: CurrentAPICallPage,
        Paginate: EventPerAPICall,
        searchElement: searchInput,
        SortBy: SortBy,
        SortType: SortType,
        eventType: FilterBy,
        startDate: startDate ? dayjs(startDate).format('YYYY-MM-DD') : undefined,
        endDate: endDate ? dayjs(endDate).format('YYYY-MM-DD') : undefined,
        locationId: selectedLocation,
        sponsor: sponsorText
      });

      if (response.data && Array.isArray(response.data.data.Events)) {
        setEventList(response.data.data.Events);
        setTotalRecords(response.data.data.pagination[0].TotalRecords);
      } else {
        setEventList([]);
        setTotalRecords(0);
      }
    } catch (error) {
      console.error('Error fetching events:', error);
      setEventList([]);
      setTotalRecords(0);
    }
  };

  const handleChange = (value: number) => {
    setCurrentPage(value);
    setCurrentAPICallPage(value);
    console.log(value, CurrentAPICallPage, CurrentPage);
  };

  const handleSearchInputChange = (e: any) => {
    setShowInputs(e.target.value);
  };

  const handleSearchButtonClick = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSearchInput(showInputs);
    setCurrentPage(1);
    setCurrentAPICallPage(1);
  };
  const handleClearSearch = () => {
    setShowInputs("");
    setSearchInput("");
    setCurrentPage(1);
    setCurrentAPICallPage(1);
  };
  const handleSort = (newSortField: string) => {
    console.log("Handle sort called");
    setEventList([]);
    setCurrentPage(1);
    setCurrentAPICallPage(1);
    startIndex = 0;
    endIndex = 0 + EventPerAPICall;
    setSortType(
      newSortField === SortBy ? (SortType === "Desc" ? "Asc" : "Desc") : "Asc"
    );
    setSortBy(newSortField);
  };
  const rowUpdate = (event: React.ChangeEvent<HTMLSelectElement>): void => {
    setEventPerAPICall(Number(event.target.value));
    setCurrentPage(1);
    setCurrentAPICallPage(1);
  };
  const data = useMemo(() => eventList, [eventList]);

  console.log("memberlist:", data);

  // const TableInstance = useTable(
  //   {
  //     columns,
  //     data,
  //   },
  //   useSortBy
  // );

  // const {
  //   getTableProps,
  //   getTableBodyProps,
  //   headerGroups,
  //   rows,
  //   prepareRow,
  // } = TableInstance;

  let index = 0; //to revisit later

  const getEventDetail = (e: any, event: IEvent) => {
    if (
      !roleCapabilites.some((obj: any) =>
        Object.values(obj).includes("events.view")
      )
    ) {
      alert("No Access");
      return;
    }
    // let data = row.original;
    console.log("getMemberDetail:", event.Id);
    console.log("getMemberDetail:", event);
    //setting as 1
    // dispatch(assignCurrentMemberBarId(data.BarId));
    if (e.target.localName == "td") {
      console.log("ROW clicked");
      dispatch(assignEvent(event));
      // dispatch(changeCurrentMemberMenu(screenConfig.viewEvent));
      navigate(routeConfig.EVENT_DETAIL_URL, { replace: false });
    }
    // if (event.target.localName == "input") {
    //   console.log("Checkbox clicked");
    //   handleChange(event);
    // }
  };

  const handleDeleteClick = (e: any, event: IEvent) => {
    e.stopPropagation(); // Prevent row click

    if (!roleCapabilites.some((obj: any) => {
      const values = Object.values(obj).map(v => String(v).toLowerCase());
      return values.includes("events.edit") ||
             values.includes("events.create") ||
             values.includes("edit") ||
             values.includes("create") ||
             values.some(v => v.includes("edit")) ||
             values.some(v => v.includes("create"));
    })) {
      alert("No Access to delete events");
      return;
    }

    setEventToDelete(event);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    if (!eventToDelete) return;

    setIsDeleting(true);
    try {
      const response = await EventServices.deleteEvent(eventToDelete.Id);
      console.log("Delete response:", response);

      if (response.data.hasErrors) {
        setShowAlertModal(true);
        setAlertTitle("Delete Error");
        setAlertBody(response.data.errors[0].message || "Failed to delete event");
      } else {
        // Success - refresh the event list
        setShowAlertModal(true);
        setAlertTitle("Success");
        setAlertBody(`Event "${eventToDelete.EventName}" (${eventToDelete.UniqueEventId}) has been deleted successfully.`);

        // Refresh the event list
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    } catch (error: any) {
      console.error("Delete error:", error);
      setShowAlertModal(true);
      setAlertTitle("Delete Error");
      setAlertBody(error.response?.data?.message || "Failed to delete event");
    } finally {
      setIsDeleting(false);
      setShowDeleteModal(false);
      setEventToDelete(null);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setEventToDelete(null);
  };

  // const downlaod = async () => {
  //   console.log("More");
  //   const response = await EventServices.downloaMemberList(searchParameters);
  //   const url = window.URL.createObjectURL(new Blob([response.data]));
  //   const link = document.createElement("a");
  //   link.href = url;
  //   link.download = "MemberReport.xlsx";
  //   // link.setAttribute('download', 'member.xlsx');
  //   document.body.appendChild(link);
  //   link.click();
  //   link!.parentNode!.removeChild(link);
  // };

  // const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const { name, value } = event.target;
  //   console.log("name:", name, "-Value", value);

  //   if (name === "allselect") {
  //     setIsAllSelectd(!isAllSelected ? true : false);
  //     const checkedvalue = memberList?.map((member) => {
  //       if (isAllSelected == true) {
  //         return {
  //           ...member,
  //           isChecked: false,
  //         };
  //       } else {
  //         return {
  //           ...member,
  //           isChecked: true,
  //         };
  //       }
  //     });
  //     setMemberList(checkedvalue);
  //     dispatch(updateMemberList(checkedvalue));
  //   } else {
  //     const checkedvalue = memberList?.map((member) => {
  //       if (member.Id == name) {
  //         return {
  //           ...member,
  //           isChecked:
  //             member.isChecked && member.isChecked != null ? false : true,
  //         };
  //       } else {
  //         return member;
  //       }
  //     });
  //     console.log("CheckedMemberList:", checkedvalue);
  //     setMemberList(checkedvalue);
  //     dispatch(updateMemberList(checkedvalue));
  //   }

  //   console.log("MemberList:", memberList);
  // };

  const createEvent = () => {
    navigate(routeConfig.CREATE_EVENT_URL, { replace: false });
  };
  const renderSortIcon = (field: string) => {
    if (field === SortBy) {
      return SortType === "Desc" ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="17"
          height="20"
          fill="#fff"
        >
          <path d="M4 13h16l-8 8z" />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="17"
          height="20"
          fill="#fff"
        >
          <path d="M12 3l8 8H4z" />
        </svg>
      );
    } else {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="17"
          height="20"
          fill="#fff"
        >
          <path d="M12 3l8 8H4z" />
          <path d="M4 13h16l-8 8z" />
        </svg>
      );
    }
  };

  const handleFilterBy = (data: any) => {
    // setValue((data.target as HTMLInputElement).value);
    console.log("handleFilterBy:", data);
    setFilterBy(data);
    setCurrentPage(1);
    setCurrentAPICallPage(1);
  };

  return (
    <>
      <div className="dashboard-content-wrapper mt-2 pb-3">
        <div className="d-flex justify-content-between mb-3">
          <h1 className="page-heading mt-4">Event List</h1>
          <form onSubmit={(e) => handleSearchButtonClick(e)}>
            <div
              style={{
                display: "flex",
                position: "relative",
                alignItems: "center",
                marginTop: "15px",
              }}
            >
              <input
                type="text"
                placeholder="Search"
                value={showInputs}
                onChange={handleSearchInputChange}
                style={{
                  padding: " 5px 0px 5px 40px",
                  backgroundColor: "rgb(250 250 250)",
                  border: "0px",
                  borderBottom: "1px solid #000",
                  width: "450px",
                }}
              />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                viewBox="0 0 29.999 30"
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "1%",
                  transform: "translateY(-50%)",
                }}
              >
                <path
                  id="Path_410"
                  data-name="Path 410"
                  d="M97.348,125.943a4.922,4.922,0,0,0,1.211-1.028l7.662-7.662c.161-.161.264-.183.448-.037a11.212,11.212,0,0,0,5.24,2.3,11.863,11.863,0,1,0-5.534-20.866,11.78,11.78,0,0,0-3.75,5.439,11.86,11.86,0,0,0,1.864,10.958c.139.183.139.279-.029.448q-3.974,3.952-7.934,7.927a2.909,2.909,0,0,0-.756,1.005v.587a1.623,1.623,0,0,0,1,.939C96.959,125.943,97.157,125.943,97.348,125.943Zm16.558-8.749a9.369,9.369,0,1,1,9.343-9.409A9.372,9.372,0,0,1,113.906,117.194Z"
                  transform="translate(-95.77 -95.95)"
                  fill="currentColor"
                ></path>
              </svg>
              <button
                className="btn"
                type="submit"
                // onClick={handleSearchButtonClick}
                style={{
                  marginLeft: "8px",
                  background: "#366287",
                  color: "#FFFFFF",
                }}
              >
                Search
              </button>
              <button
                className="btn"
                type="button"
                onClick={handleClearSearch}
                style={{
                  marginLeft: "8px",
                  background: "#757575",
                  color: "#FFFFFF",
                }}
              >
                Clear
              </button>
            </div>
          </form>
          <div className="dashboard-menu-button">
            <ButtonWithIcon
              icon={<EventsIcon height={30} width={30} />}
              buttontext="New Event"
              onClick={createEvent}
            />
          </div>
        </div>
        <div className="d-flex justify-content-end">
          {/* <FormControl>
            <FormLabel id="demo-radio-buttons-group-label">Filter By</FormLabel>
            <RadioGroup row aria-labelledby="demo-radio-buttons-group-label" defaultValue="All" name="radio-buttons-group" onChange={handleFilterBy}>
              <FormControlLabel value="" control={<Radio />} label="All" />
              <FormControlLabel value="Function" control={<Radio />} label="Function" />
              <FormControlLabel value="Seminar" control={<Radio />} label="Seminar" />
              <FormControlLabel value="Video" control={<Radio />} label="Video" />
            </RadioGroup>
          </FormControl> */}
          {/* <label>Filter By:</label>
          <select onChange={handleFilterBy}>
            <option value="">All</option>
            <option value="Function">Function</option>
            <option value="Seminar">Seminar</option>
            <option value="Video">Video</option>
          </select> */}
        </div>
        <div className="memberlist-table">
          <Nav
            className="custom-tabs d-flex justify-content-start text-center align-item-center"
            variant="tabs"
            style={{ marginBottom: "1rem" }}
            activeKey={FilterBy}
          >
            <div className="heading_small" style={{ marginRight: "0.5rem" }}>
              Filter By:
            </div>
            <Nav.Item>
              <Nav.Link
                className="nav-small-label nav-tag-style"
                eventKey=""
                onClick={() => handleFilterBy("")}
              >
                All
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                className="nav-small-label nav-tag-style"
                eventKey="Function"
                onClick={() => handleFilterBy("Function")}
              >
                Function
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                className="nav-small-label nav-tag-style"
                eventKey="Seminar"
                onClick={() => handleFilterBy("Seminar")}
              >
                Seminar
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                className="nav-small-label nav-tag-style"
                eventKey="Video"
                onClick={() => handleFilterBy("Video")}
              >
                Video
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip id="filter-tooltip">
                    {getFilterText()}
                  </Tooltip>
                }
              >
                <Nav.Link
                  className={` d-none nav-small-label nav-tag-style ${hasFilters ? 'active' : ''}`}
                  eventKey="More"
                  onClick={() => setShowMoreModal(true)}
                  style={{
                    backgroundColor: hasFilters ? '#04aa6d' : 'transparent',
                    color: hasFilters ? 'white' : '#000000',
                    border:  '1px solid #04aa6d'
                  }}
                >
                  More
                </Nav.Link>
              </OverlayTrigger>
            </Nav.Item>
          </Nav>
          <table
            style={{
              borderCollapse: "collapse",
              width: "100%",
              borderTop: "2px solid #04aa6d",
            }}
          >
            <thead>
              <tr>
                {/* <th>
                  <input
                    type="checkbox"
                    name="allselect"
                    // checked={!userData.some((user) => user?.isChecked !== true)}
                    // onChange={handleChange}
                  />
                </th> */}
                <th
                  className="eventid-table"
                  onClick={() => handleSort("UniqueEventId")}
                >
                  Event ID {renderSortIcon("UniqueEventId")}
                </th>
                <th
                  className="eventname-table"
                  onClick={() => handleSort("EventName")}
                >
                  Event Name {renderSortIcon("EventName")}
                </th>
                <th
                  className="eventype-table"
                  onClick={() => handleSort("EventType")}
                >
                  Event Type {renderSortIcon("EventType")}
                </th>
                <th
                  className="eventdate-table"
                  onClick={() => handleSort("StartDateTime")}
                >
                  Start Date Time {renderSortIcon("StartDateTime")}
                </th>
                <th
                  className="eventdate-table"
                  onClick={() => handleSort("EndDateTime")}
                >
                  End Date Time {renderSortIcon("EndDateTime")}
                </th>
                <th
                  className="eventattendee-table"
                  onClick={() => handleSort("NumberOfAttendee")}
                >
                  Number Of Attendee {renderSortIcon("NumberOfAttendee")}
                </th>
                <th className="action-table" style={{ minWidth: "100px", backgroundColor: "#04aa6d" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {eventList.map((event) => (
                <tr key={event.Id} onClick={(e) => getEventDetail(e, event)}>
                  {/* <th>
                    <input
                      type="checkbox"
                      name={event.Id as string}
                      // checked={event?.isChecked}
                      // onChange={(e) => handleChange(e)}
                    />
                  </th> */}
                  <td>{event.UniqueEventId} </td>
                  <td>{event.EventName} </td>
                  <td>{event.EventType} </td>
                  <td>
                    {event.StartDateTime != null
                      ? dayjs(event.StartDateTime).format("MM-DD-YYYY hh:mm A")
                      : "--"}
                  </td>
                  <td>
                    {event.EndDateTime != null
                      ? dayjs(event.EndDateTime).format("MM-DD-YYYY  hh:mm A")
                      : "--"}
                  </td>
                  <td>{event.NumberOfAttendee}</td>
                  <td style={{ minWidth: "100px" }}>
                    {(() => {
                      console.log("Role capabilities:", roleCapabilites);
                      console.log("Has events.edit:", roleCapabilites.some((obj: any) =>
                        Object.values(obj).includes("events.edit")
                      ));
                      return null;
                    })()}
                    {roleCapabilites.some((obj: any) => {
                      const values = Object.values(obj).map(v => String(v).toLowerCase());
                      return values.includes("events.edit") ||
                             values.includes("events.create") ||
                             values.includes("edit") ||
                             values.includes("create") ||
                             values.some(v => v.includes("edit")) ||
                             values.some(v => v.includes("create"));
                    }) ? (
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={(e) => handleDeleteClick(e, event)}
                        title="Delete Event"
                      >
                        Delete
                      </button>
                    ) : (
                      <span className="text-muted" style={{ fontSize: "12px" }}>No Access</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Modal show={showMoreModal} onHide={() => setShowMoreModal(false)} centered backdropStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
          <div className="modal-content" style={{ backgroundColor: 'white' }}>
          <Modal.Header closeButton style={{ backgroundColor: 'white', padding: '1rem' }}>
            <Modal.Title>More Filters</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ backgroundColor: 'white', padding: '1rem' }}>
            <div className="d-flex flex-column gap-3">
              <div className="d-flex flex-column gap-2">
                <div className="d-flex flex-column">
                  <label className="mb-1">Start Date</label>
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    className="form-control"
                    dateFormat="MM/dd/yyyy"
                  />
                </div>
                <div className="d-flex flex-column">
                  <label className="mb-1">End Date</label>
                  <DatePicker
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    className="form-control"
                    dateFormat="MM/dd/yyyy"
                  />
                </div>
              </div>
              <div className="d-flex flex-column">
                <label className="mb-1">Location Info</label>
                <select
                  value={selectedLocation!!}
                  onChange={(e) => setSelectedLocation(e.target.value === "" ? null : Number(e.target.value))}
                  className="form-control"
                >
                  <option value="">Select Location</option>
                  {locationList.map((location) => (
                    <option key={location.Id} value={location.Id!!}>
                      {location.Location}
                    </option>
                  ))}
                </select>
              </div>
              <div className="d-flex flex-column">
                <label className="mb-1">Sponsor</label>
                <input
                  type="text"
                  value={sponsorText}
                  onChange={(e) => setSponsorText(e.target.value)}
                  placeholder="Enter sponsor name"
                  className="form-control"
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: 'white', padding: '1rem' }}>
            <Button variant="secondary" onClick={() => {
              setHasFilters(false);
              setStartDate(null);
              setEndDate(null);
              setSelectedLocation(null);
              setSponsorText("");
              setShowMoreModal(false);
            }} style={{
              backgroundColor: '#f8f9fa',
              borderColor: '#dee2e6',
              color: '#6c757d',
              padding: '8px 16px',
              borderRadius: '4px',
              marginRight: '8px'
            }}>
              Close
            </Button>
            <Button variant="primary" onClick={handleApplyFilters} style={{
              backgroundColor: '#04aa6d',
              borderColor: '#04aa6d',
              color: 'white',
              padding: '8px 16px',
              borderRadius: '4px',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
            }}>
              Apply Filters
            </Button>
          </Modal.Footer>
          </div>
        </Modal>
      </div>
      <div
        className="container mb-2"
        style={{ paddingTop: "10px", borderTop: "1px solid #ddd" }}
      >
        <div className="grid left"></div>
        {/* Pagenation-start */}
        <div className="grid center">
          <div
            className="horizontal-wrapper-centeraligned"
            style={{ marginTop: "10px" }}
          >
            <div
              className="round-button-div"
              style={{ width: "30px", height: "30px", marginRight: "10px" }}
            >
              <RoundButtonWithIcon
                icon={<LeftArrowIcon height={15} width={8} />}
                onClick={() => handleChange(CurrentPage - 1)}
                disabled={CurrentPage === 1}
              />
            </div>
            {eventList.length > 1 ? (
              <div className="heading_medium">
                {" "}
                <span style={{ fontWeight: "500" }}>
                  {1 + (CurrentPage - 1) * EventPerAPICall}{" "}
                </span>{" "}
                -{" "}
                <span style={{ fontWeight: "500" }}>
                  {eventList.length + (CurrentPage - 1) * EventPerAPICall}{" "}
                </span>
                of <span style={{ fontWeight: "500" }}>{TotalRecords} </span>{" "}
                Events
              </div>
            ) : (
              <div>
                <div className="heading_medium">
                  <span style={{ fontWeight: "500" }}>{TotalRecords} </span>{" "}
                  Events
                </div>
              </div>
            )}
            <div
              style={{
                height: "30px",
                width: "30px",
                transform: "rotate(180deg)",
                marginLeft: "10px",
              }}
            >
              {" "}
              <RoundButtonWithIcon
                icon={<LeftArrowIcon height={15} width={8} />}
                onClick={() => handleChange(CurrentPage + 1)}
                disabled={
                  CurrentPage === Math.ceil(TotalRecords / EventPerAPICall)
                }
              />{" "}
            </div>
          </div>
        </div>
        {/* Pagenation-end */}
        <div className="grid right">
          <div className="w-100 mt-2">
            <select
              className="dropdown-control-large-insidetextfield"
              name="pagesize"
              style={{ border: "1px solid #ddd", height: "30px" }}
              onChange={(e) => {
                rowUpdate(e);
              }}
              value={EventPerAPICall}
            >
              <option value="10">10 rows</option>
              <option value="25">25 rows</option>
              <option value="50">50 rows</option>
              <option value="100">100 rows</option>
              <option value="150">150 rows</option>
              <option value="200">200 rows</option>
            </select>
          </div>
        </div>
      </div>
      {showAlertModal ? (
        <AlertWithModal
          title={alertTitle}
          body={alertBody}
          show={showAlertModal}
          onClose={() => setShowAlertModal(false)} // Close the modal
        />
      ) : (
        <></>
      )}

      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={handleDeleteCancel} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete Event</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete this event?</p>
          {eventToDelete && (
            <div>
              <strong>Event Name:</strong> {eventToDelete.EventName}<br />
              <strong>Event ID:</strong> {eventToDelete.UniqueEventId}<br />
              <strong>Start Date:</strong> {eventToDelete.StartDateTime ? dayjs(eventToDelete.StartDateTime).format("MM-DD-YYYY hh:mm A") : "--"}<br />
            </div>
          )}
          <p className="text-danger mt-3">
            <strong>Warning:</strong> This action cannot be undone. All related data including orders, registrations, and credits will be permanently deleted.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteCancel} disabled={isDeleting}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDeleteConfirm} disabled={isDeleting}>
            {isDeleting ? "Deleting..." : "Delete Event"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EventList;
